import { useCallback, useRef } from 'react'

import { type AuthorPreview } from '@/entities/authors'
import { ROUTES } from '@/shared/config'
import { ContentWrapper, HeaderContent } from '@/shared/ui'
import { AlbumForm } from '@/widgets/AlbumForm'
import { AuthorForm, authorFormModalOpened } from '@/widgets/AuthorForm'
import { Breadcrumb, Layout } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useLocation } from 'react-router-dom'

import { AlbumCreatePageGate } from './model/album-create.model'

export const AlbumCreatePage = () => {
  const location = useLocation()
  const state = location.state as {
    author?: AuthorPreview
  }
  const author = state?.author

  const openAuthorsFormModal = useUnit(authorFormModalOpened)

  const onAuthorSubmitted = useRef<(id: string) => void>(() => {})
  const onAuthorButtonClick = useCallback(
    (callback: (id: string) => void) => {
      onAuthorSubmitted.current = callback
      openAuthorsFormModal()
    },
    [openAuthorsFormModal],
  )

  return (
    <Layout>
      <AlbumCreatePageGate />
      <AuthorForm
        isModal
        onSubmitted={(authorId: string) => onAuthorSubmitted.current(authorId)}
      />
      <HeaderContent
        breadcrumbSlot={
          <Breadcrumb
            items={[
              ...(author
                ? [
                    { title: 'Авторы' },
                    {
                      title: (
                        <Link
                          to={ROUTES.AUTHORS.EDIT.replace(':id', author.id)}
                        >
                          {author.nickname}
                        </Link>
                      ),
                    },
                  ]
                : [
                    { title: 'Контент' },
                    { title: 'Коллекции' },
                    {
                      title: (
                        <Link to={ROUTES.COLLECTIONS.ALBUMS}>Альбомы</Link>
                      ),
                    },
                  ]),
              {
                title: 'Создание альбома',
              },
            ]}
          />
        }
        title="Создание альбома"
        description="Раздел предоставляет возможность добавлять новый контент в каталог и управлять его параметрами"
      />

      <ContentWrapper>
        <AlbumForm onAuthorButtonClick={onAuthorButtonClick} />
      </ContentWrapper>
    </Layout>
  )
}
